export const CloseDrawer = "closeDrawer ";
export const RefreshReport = "refreshReport ";
export const RefreshTodoWidget = "RefreshTodoWidget ";
export const ToggleNotifications = "toggleNotifications ";
